import { Icon } from './Icon';

export interface DogsInPillProps {
  // Dogs in that day (evening occupancy). Compute with occupancyByDate so every
  // surface shows the same number.
  count: number;
  // Render a greyed pill at zero (planning grids want to see empty days) or hide
  // it entirely (dense calendars stay quiet). Default: show.
  showZero?: boolean;
}

// The dogs-in cue — a paw icon + count — used wherever a day's occupancy is
// shown (roster grid, bookings calendar). One component so the icon, the count
// and the styling stay identical across pages.
export function DogsInPill({ count, showZero = true }: DogsInPillProps) {
  if (count === 0 && !showZero) return null;
  return (
    <span className={'dogs-in' + (count === 0 ? ' zero' : '')} title={`${count} dogs in`}>
      <Icon name="paw" size={12} />
      <span className="mono">{count}</span>
    </span>
  );
}
